<div class="main no-padding">
  <header-menu></header-menu>


  <div class="colab-manager-wrapper">

    <div style="float: none; margin: 0 auto;" class="content colab-manager-content no-padding">

        <!-- Content -->

        <div class="colab-manager-content-component colab-registration fade-in-animation">

          <div class="row" style="margin: 0;">

              <div class="col-md-6 col-sm-12">
                <div class="area-to-overlay">

                    <h1 class="no-margin">Meus Dados</h1>

                    <!-- Informações básicas -->
                    <div class="col-md-12 col-sm-12 no-padding basic-info-wrp">

                      <h3>{{ 'COMPANY.MANAGER.FORM.SUBSECTION_TITLE_BASIC_INFO' | translate }}</h3>

                      <div class="col-md-6 col-sm-12 form-padding-right">
                        <div [ngClass]="{'form-group': true, 'has-error': hasError('first_name')}">
                            <label for="firstName">{{ 'COMPANY.MANAGER.FORM.NAME_LABEL' | translate }}*</label>
                            <input type="text" class="form-control" id="firstName" [(ngModel)]="account.first_name" placeholder="" (change)="changeToUpdateAccount($event, 'first_name')">
                            <span class="error-description">{{ getError('first_name') | translate }}</span>
                        </div>
                      </div>

                      <div class="col-md-6 col-sm-12 form-padding-left">
                        <div [ngClass]="{'form-group': true, 'has-error': hasError('surname')}">
                            <label for="name">{{ 'COMPANY.MANAGER.FORM.SURNAME_LABEL' | translate }}*</label>
                            <input type="text" class="form-control" id="surname" [(ngModel)]="account.surname" placeholder="" (change)="changeToUpdateAccount($event, 'surname')">
                            <span class="error-description">{{ getError('surname') | translate }}</span>
                        </div>
                      </div>

                      <div [ngClass]="{'form-group': true, 'has-error': hasError('email')}">
                          <label for="email">{{ 'COMPANY.MANAGER.FORM.EMAIL_LABEL' | translate }}*</label>
                          <input type="email" class="form-control" id="email" [(ngModel)]="account.email" placeholder="" (change)="changeToUpdateAccount($event, 'email')">
                          <span class="error-description">{{ getError('email') | translate }}</span>
                      </div>

                      <div class="clearfix"></div>

                      <div class="col-md-6 col-sm-12 form-padding-right">
                        <div [ngClass]="{'form-group': true, 'has-error': hasError('cpf')}">
                          <label for="cpf">{{ 'COMPANY.MANAGER.FORM.CPF_LABEL' | translate }}*</label>
                          <input type="text" class="form-control" id="cpf" [textMask]="{mask: cpfMask}" (change)="changeToUpdateAccount($event, 'cpf')" [(ngModel)]="account.cpf" [disabled]="this.cpf ? 'disabled': null">
                          <span class="error-description">{{ getError('cpf') | translate }}</span>
                        </div>
                      </div>
                    </div>
                    <!-- / Informações básicas -->


                    <!-- Opcionais -->
                    <div class="col-md-12 col-sm-12 no-padding optional-info-wrp">

                      <h3>{{ 'COMPANY.MANAGER.FORM.SUBSECTION_TITLE_OPTIONAL_INFO' | translate }}</h3>

                      <!-- Dados pessoais -->
                      <h3  *ngIf="getTypeBusiness() === 'company'">{{ 'COMPANY.MANAGER.FORM.SUBSECTION_TITLE_PERSONAL_INFO' | translate }}</h3>

                      <div *ngIf="getTypeBusiness() === 'company'" [ngClass]="{'form-group': true, 'has-error': hasError('employeeRegistrationNumber')}">
                          <label for="employee_registration_number">{{ 'COMPANY.MANAGER.FORM.EMPLOYEE_REGISTRATION_NUMBER_LABEL' | translate }}</label>
                          <input type="text" class="form-control" id="employee_registration_number" [(ngModel)]="account.employeeRegistrationNumber" placeholder="" (change)="changeToUpdateAccount($event, 'employeeRegistrationNumber')">
                          <span class="error-description">{{ getError('employeeRegistrationNumber') | translate }}</span>
                      </div>

                      <div *ngIf="getTypeBusiness() === 'company'" class="form-group">
                          <label for="email_personal">{{ 'COMPANY.MANAGER.FORM.EMPLOYEE_PERSONAL_EMAIL_LABEL' | translate }}</label>
                          <input type="email" class="form-control" id="email_personal" [(ngModel)]="account.emailPersonal" placeholder=""  (change)="changeToUpdateAccount($event, 'emailPersonal')">
                      </div>

                      <div class="form-group">
                          <label for="gender">{{ 'COMPANY.MANAGER.FORM.GENDER_LABEL' | translate }}</label>
                          <select class="form-control" id="gender" [(ngModel)]="account.gender" (change)="changeToUpdateAccount($event, 'gender')">
                            <option value="female">{{ 'COMPANY.MANAGER.FORM.GENDER_FEMALE' | translate }}</option>
                            <option value="male">{{ 'COMPANY.MANAGER.FORM.GENDER_MALE' | translate }}</option>
                            <option value="other">{{ 'COMPANY.MANAGER.FORM.GENDER_OTHER' | translate }}</option>
                          </select>
                      </div>

                      <div *ngIf="getTypeBusiness() === 'company'" class="form-group">
                        <label style="display: block;">{{ 'COMPANY.MANAGER.FORM.HAS_CHILD_LABEL' | translate }}</label>
                        <div class="colab-has-childs" *ngIf="!isLoading">
                          <div class="col-md-6 has-child-radio">
                            <input type="radio" name="hasChilds" [(ngModel)]="account.hasChilds" value="1" (change)="changeToUpdateAccount($event, 'hasChilds')">
                            <label>{{ 'COMPANY.MANAGER.FORM.HAS_CHILD_YES' | translate }}</label>
                          </div>
                          <div class="col-md-6 has-child-radio">
                              <input type="radio" name="hasChilds" [(ngModel)]="account.hasChilds" value="0" (change)="changeToUpdateAccount($event, 'hasChilds')">
                            <label>{{ 'COMPANY.MANAGER.FORM.HAS_CHILD_NO' | translate }}</label>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                          <label for="phone_number">{{ 'COMPANY.MANAGER.FORM.PHONE_NUMBER_LABEL' | translate }}</label>
                          <input type="text" class="form-control" id="phone_number" [textMask]="{mask: telephoneMask}" [(ngModel)]="account.phone" placeholder="" (change)="changeToUpdateAccount($event, 'phone')">
                      </div>

                      <div class="col-md-6 col-sm-12 form-padding-right">
                        <div class="form-group">
                            <label for="birth_date">{{ 'COMPANY.MANAGER.FORM.BIRTHDATE_LABEL' | translate }}</label>
                            <input type="date" class="form-control" id="birth_date" [(ngModel)]="account.birthDate" placeholder="" (change)="changeToUpdateAccount($event, 'birthDate')">
                        </div>
                      </div>

                      <div *ngIf="getTypeBusiness() === 'company'" class="col-md-6 col-sm-12 form-padding-left">
                        <div class="form-group">
                            <label for="cep">{{ 'COMPANY.MANAGER.FORM.CEP_LABEL' | translate }}</label>
                            <input type="text" class="form-control" id="cep" [textMask]="{mask: cepMask}" [(ngModel)]="account.cep" placeholder="" (change)="changeToUpdateAccount($event, 'cep')">
                        </div>
                      </div>

                      <div class="clearfix"></div>


                      <!-- /Dados pessoais -->


                      <!-- Dados profissionais -->
                      <h3 *ngIf="getTypeBusiness() === 'company'">{{ 'COMPANY.MANAGER.FORM.SUBSECTION_TITLE_PROFESSIONAL_INFO' | translate }} </h3>

                      <div *ngIf="getTypeBusiness() === 'company'" class="col-md-6 col-sm-12 form-padding-right">
                        <div class="form-group">
                          <label for="job_position">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_LABEL' | translate }}</label>
                            <select class="form-control" id="job_position" [(ngModel)]="account.jobPosition" (change)="changeToUpdateAccount($event, 'jobPosition')">
                              <option value="trainee">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_TRAINEE' | translate }}</option>
                              <option value="assistant">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_ASSISTANT' | translate }}</option>
                              <option value="analyst">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_ANALYST' | translate }}</option>
                              <option value="coordinator">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_COORDINATOR' | translate }}</option>
                              <option value="manager">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_MANAGER' | translate }}</option>
                              <option value="director">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_DIRECTOR' | translate }}</option>
                              <option value="superintendent">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_SUPERINTENDENT' | translate }}</option>
                              <option value="president">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_PRESIDENT' | translate }}</option>
                              <option value="other">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_OTHER' | translate }}</option>
                            </select>
                        </div>
                      </div>

                      <div class="clearfix"></div>

                      <div class="buttons-actions-colab-form" *ngIf="!isLoading">
                        <button class="btn btn-orange" (click)="updateAccount()">{{ 'COMPANY.MANAGER.FORM.BUTTON_SAVE_CHANGES' | translate }}</button>
                      </div>

                      <!-- /Dados profissionais -->

                      <!-- Alterar Senha -->
                      <div class="clearfix"></div>

                      <h3>Alterar Senha</h3>

                      <div [ngClass]="{'form-group': true, 'has-error': hasError('password')}">
                        <label for="password">Senha atual*</label>
                        <input type="password" class="form-control" id="password" [(ngModel)]="accountPassword.password" placeholder="">
                        <span class="error-description">{{ getError('password') | translate }}</span>
                      </div>

                      <div [ngClass]="{'form-group': true, 'has-error': hasError('password_new')}">
                        <label for="password_new">Nova senha*</label>
                        <input type="password" class="form-control" id="password_new" [(ngModel)]="accountPassword.password_new" placeholder="">
                        <span class="error-description">{{ getError('password_new') | translate }}</span>
                      </div>

                      <div [ngClass]="{'form-group': true, 'has-error': hasError('password_new_confirmation')}">
                        <label for="password_new_confirmation">Confirme a senha nova*</label>
                        <input type="password" class="form-control" id="password_new_confirmation" [(ngModel)]="accountPassword.password_new_confirmation" placeholder="">
                        <span class="error-description">{{ getError('password_new_confirmation') | translate }}</span>
                      </div>

                      <div class="clearfix"></div>

                      <div class="buttons-actions-colab-form" *ngIf="!isLoading">
                        <button class="btn btn-orange" (click)="updatePassword()">Alterar Senha</button>
                      </div>
                      <!-- / Alterar senha -->

                      <div class="loader-wrp" *ngIf="isLoading">
                        <div class="loader"><span></span><span></span><span></span></div>
                      </div>

                    </div>
                    <!-- / Opcionais -->

                    <div class="loading-overlay" *ngIf="isLoading">
                      <div class="loader-wrp">
                        <div class="loader"><span></span><span></span><span></span></div>
                        <p> {{ 'LOADING' | translate }}</p>
                      </div>
                    </div>

                    <div class="clearfix"></div>

                </div>
              </div>


          </div>
        </div>

        <!-- / Content -->

    </div>
    <!-- / colab-manager-content -->

    <div class="clearfix"></div>

  </div>
  <!-- / colab-manager-wrapper -->

</div>
